// Job Status Constants
export const JobStatus = {
  ALL: null,
  PENDING: 'pending',
  STARTED: 'started',
  RUNNING: 'running',
  COMPLETED: 'completed',
  FAILED: 'failed'
}

// Job Chain Status Constants
export const JobChainStatus = {
  ALL: null,
  PENDING: 'pending',
  RUNNING: 'running',
  COMPLETED: 'completed',
  FAILED: 'failed',
  CANCELLED: 'cancelled'
}

// Job status configuration for UI display
export const JobStatusConfig = {
  [JobStatus.PENDING]: { 
    tone: 'info',
    translationKey: 'Jobs.status.pending'
  },
  [JobStatus.STARTED]: { 
    tone: 'info-on-surface',
    translationKey: 'Jobs.status.started'
  },
  [JobStatus.RUNNING]: { 
    tone: 'attention',
    translationKey: 'Jobs.status.running'
  },
  [JobStatus.COMPLETED]: { 
    tone: 'success',
    translationKey: 'Jobs.status.completed'
  },
  [JobStatus.FAILED]: { 
    tone: 'critical',
    translationKey: 'Jobs.status.failed'
  }
}

// Job chain status configuration for UI display
export const JobChainStatusConfig = {
  [JobChainStatus.PENDING]: { 
    tone: 'info',
    translationKey: 'Jobs.chainStatus.pending'
  },
  [JobChainStatus.RUNNING]: { 
    tone: 'attention',
    translationKey: 'Jobs.chainStatus.running'
  },
  [JobChainStatus.COMPLETED]: { 
    tone: 'success',
    translationKey: 'Jobs.chainStatus.completed'
  },
  [JobChainStatus.FAILED]: { 
    tone: 'critical',
    translationKey: 'Jobs.chainStatus.failed'
  },
  [JobChainStatus.CANCELLED]: { 
    tone: 'warning',
    translationKey: 'Jobs.chainStatus.cancelled'
  }
}

// Helper function to check if job needs refresh
export const needsRefresh = (status) => {
  return status === JobStatus.PENDING || 
         status === JobStatus.STARTED || 
         status === JobStatus.RUNNING
}

// Helper function to check if chain needs refresh
export const chainNeedsRefresh = (status) => {
  return status === JobChainStatus.PENDING || 
         status === JobChainStatus.RUNNING
}